// extracted by mini-css-extract-plugin
export default {"password":"index_password_Nqe7- clearfix","input":"index_input_b7b6f","loginregi":"index_loginregi_CdyHg"};